import { useDispatch } from "react-redux";
import Loader from "react-loader-spinner";
import { Button, Card, Col, Row, Table } from "react-bootstrap";
import { faSitemap } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import { useCallback, useState, useEffect, useRef, Fragment } from "react";
import { PencilFill, PlusSquare, Trash, CheckSquare, DashCircle, CaretRight, CaretLeft, Search, CaretLeftFill } from "react-bootstrap-icons"
import { getAccountLevelOList, getAccountLevelOneList, getAccountLevelTwoList, getAccountLevelThreeList, deleteAccount, editAccount, addNewAccount, findSpecificAccount, getNextAccountCode } from "../store/api/DocumentsAPI";


const AccountsChart = () => {
    const dispatch = useDispatch();
    const skip = useRef(0);
    const sepecificAcc = useRef("");
    const [levelO, getLevelO] = useState([]);
    const [levelOne, getLevelOne] = useState([]);
    const [levelTwo, getLevelTwo] = useState([]);
    const [levelThree, getLevelThree] = useState([]);
    const [foundAccounts, getFoundAccounts] = useState({ Result: [], TotalCount: 0 });
    const [currentLevelO, setCurrLevelO] = useState(null);
    const [currentLevelOne, setCurrLevelOne] = useState(null);
    const [currentLevelTwo, setCurrLevelTwo] = useState(null);
    const [currentLevelThree, setCurrLevel3] = useState(null);
    const [colWidth, setColWidth] = useState({ LevelO: 4, LevelOne: 4, Level2_3: 2 });

    const getLevelOnes = useCallback((levelO) => {
        // if (currentLevelO && Number(currentLevelO.AccountID) === Number(levelO.AccountID)) {
        //     return;
        // }
        setCurrLevelO({ ...levelO });
        getLevelTwo([]);
        getLevelThree([]);
        setCurrLevelOne(null);
        setCurrLevelTwo(null);
        setCurrLevel3(null);
        getAccountLevelOneList(levelO.AccountID, getLevelOne);
    })
    const getLevelTwoes = useCallback((levelOne) => {
        // if (currentLevelOne && Number(currentLevelOne.AccountID) === Number(levelOne.AccountID)) {
        //     return;
        // }
        setCurrLevelOne({ ...levelOne });
        getLevelThree([]);
        setCurrLevelTwo(null);
        setCurrLevel3(null);
        getAccountLevelTwoList(levelOne.AccountID, getLevelTwo);
    });
    const getLevelThrees = useCallback((levelTwo) => {
        // if (currentLevelTwo && Number(currentLevelTwo.AccountID) === Number(levelTwo.AccountID)) {
        //     return;
        // }
        setCurrLevelTwo({ ...levelTwo });
        setCurrLevel3(null);
        getAccountLevelThreeList(levelTwo.AccountID, getLevelThree);
    });
    const onChangeInput = useCallback((level, data, dataName) => {
        if (!data || data === "") {
            return;
        }
        switch (level) {
            case 0:
                currentLevelO[dataName] = data;
                setCurrLevelO({ ...currentLevelO });
                break;
            case 1:
                currentLevelOne[dataName] = data;
                setCurrLevelOne({ ...currentLevelOne });
                break;
            case 2:
                currentLevelTwo[dataName] = data;
                setCurrLevelTwo({ ...currentLevelTwo });
                break;
            case 3:
                currentLevelThree[dataName] = data;
                setCurrLevel3({ ...currentLevelThree });
            default:
                break;
        }
    });
    function editAcc(level) {
        const data = level === 0 ? currentLevelO :
            level === 1 ? currentLevelOne :
                level === 2 ? currentLevelTwo :
                    currentLevelThree;
        if (level === 3) {
            const hardCodes = ["Banks", "CommercialBed", "Agents", "CommercialBes", "Personel", "Purchase", "ReturnFromPurchase", "Sale", "ReturnFromSale"];
            const pHardCodes = ["بانکها", "بدهکاران تجاری", "نمایندگی ها", "بستانکاران تجاری", "پرسنل", "خرید", "برگشت از خرید", "فروش", "برگشت از فروش"];
            const section = ["مدیریت حسابهای بانکی", "طرف حساب ها", "مدیریت پرسنل / نمایندگی ها", "طرف حساب ها", "مدیریت پرسنل / نمایندگی ها", "مدیریت کالاها", "مدیریت کالاها", "مدیریت کالاها", "مدیریت کالاها"];
            const indx = hardCodes.findIndex(h => h === currentLevelTwo.HardCode);
            if (indx >= 0) {
                const msg = `برای ویرایش ${pHardCodes[indx]} به بخش ${section[indx]} مراجعه کنید`;
                setErrorDialog(dispatch, msg, "ویرایش حساب");
                return;
            }
        }
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ویرایش حساب");
                return;
            }
            if (level === 0) {
                getLevelOne([]);
                getLevelTwo([]);
                getLevelThree([]);
                setCurrLevelOne(null);
                setCurrLevelTwo(null);
                setCurrLevel3(null);
                getAccountLevelOList(getLevelO);
            }
            else if (level === 1) {
                getLevelOnes(currentLevelO);
            }
            else if (level === 2) {
                getLevelTwoes(currentLevelOne);
            }
            else if (level === 3) {
                getLevelThrees(currentLevelTwo);
            }
        }
        editAccount(data, onSuccess);
    }
    function prepareForAdd(level) {
        if (level === 0) {
            getLevelOne([]);
            getLevelTwo([]);
            getLevelThree([]);
            setCurrLevelOne(null);
            setCurrLevelTwo(null);
            setCurrLevel3(null);
            const onGetCode = (res) => {
                if (res.Data) {
                    setCurrLevelO({ AccountID: 0, AccountCode: res.Data, AccountName: "", IsPredefined: false, Level: 0 });
                }
            }
            getNextAccountCode(0, onGetCode);

        }
        else if (level === 1) {
            getLevelTwo([]);
            getLevelThree([]);
            setCurrLevelTwo(null);
            setCurrLevel3(null);
            const onGetCode = (res) => {
                if (res.Data) {
                    setCurrLevelOne({ AccountID: 0, AccountCode: res.Data, AccountName: "", IsPredefined: false, ParentID: currentLevelO.AccountID, Level: 1 });
                }
            }
            getNextAccountCode(1, "", onGetCode);

        }
        else if (level === 2) {
            setCurrLevel3(null);
            getLevelThree([]);
            const onGetCode = (res) => {
                if (res.Data) {
                    setCurrLevelTwo({ AccountID: 0, AccountCode: res.Data, AccountName: "", ParentID: currentLevelOne.AccountID, Level: 2 });
                }
            }
            getNextAccountCode(2, currentLevelOne.HardCode, onGetCode);
        }
        else if (level === 3) {
            const onGetCode = (res) => {
                if (res.Data) {
                    setCurrLevel3({ AccountID: 0, AccountCode: res.Data, AccountName: "", ParentID: currentLevelTwo.AccountID, Level: 3 });
                }
            }
            getNextAccountCode(3, currentLevelTwo.HardCode, onGetCode);
        }
    }
    function cancelAdd(level) {
        if (level === 0) {
            getLevelOne([]);
            getLevelTwo([]);
            getLevelThree([]);
            setCurrLevelO(null);
            setCurrLevelOne(null);
            setCurrLevelTwo(null);
            setCurrLevel3(null);
        }
        else if (level === 1) {
            getLevelTwo([]);
            getLevelThree([]);
            setCurrLevelOne(null);
            setCurrLevelTwo(null);
            setCurrLevel3(null);
        }
        else if (level === 2) {
            getLevelThree([]);
            setCurrLevelTwo(null);
            setCurrLevel3(null);
        }
        else if (level === 3) {
            setCurrLevel3(null);
        }
    }
    function addAcc(level) {
        const data = level === 0 ? currentLevelO :
            level === 1 ? currentLevelOne :
                level === 2 ? currentLevelTwo :
                    currentLevelThree;
        if ((data.AccountName ?? "") === "" || (data.AccountCode ?? "") === "") {
            return;
        }
        if (level === 3) {
            const hardCodes = ["Banks", "CommercialBed", "Agents", "CommercialBes", "Personel", "Purchase", "ReturnFromPurchase", "Sale", "ReturnFromSale"];
            const pHardCodes = ["بانکها", "بدهکاران تجاری", "نمایندگی ها", "بستانکاران تجاری", "پرسنل", "خرید", "برگشت از خرید", "فروش", "برگشت از فروش"];
            const section = ["مدیریت حسابهای بانکی", "طرف حساب ها", "مدیریت پرسنل / نمایندگی ها", "طرف حساب ها", "مدیریت پرسنل / نمایندگی ها", "مدیریت کالاها", "مدیریت کالاها", "مدیریت کالاها", "مدیریت کالاها"];
            const indx = hardCodes.findIndex(h => h === currentLevelTwo.HardCode);
            if (indx >= 0) {
                const msg = `برای افزودن ${pHardCodes[indx]} به بخش ${section[indx]} مراجعه کنید`;
                setErrorDialog(dispatch, msg, "افزودن حساب");
                return;
            }
        }
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "افزودن حساب");
                return;
            }
            if (level === 0) {
                getLevelOne([]);
                getLevelTwo([]);
                getLevelThree([]);
                setCurrLevelO(null);
                setCurrLevelOne(null);
                setCurrLevelTwo(null);
                setCurrLevel3(null);
                getAccountLevelOList(getLevelO);
            }
            else if (level === 1) {
                getLevelOnes(currentLevelO);
            }
            else if (level === 2) {
                getLevelTwoes(currentLevelOne);
            }
            else if (level === 3) {
                getLevelThrees(currentLevelTwo);
            }
        }
        addNewAccount(data, onSuccess);
    }
    function deleteAcc(level, id) {
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "افزودن حساب");
                return;
            }
            if (level === 0) {
                getLevelOne([]);
                getLevelTwo([]);
                getLevelThree([]);
                setCurrLevelO(null);
                setCurrLevelOne(null);
                setCurrLevelTwo(null);
                setCurrLevel3(null);
                getAccountLevelOList(getLevelO);
            }
            else if (level === 1) {
                getLevelOnes(currentLevelO);
            }
            else if (level === 2) {
                getLevelTwoes(currentLevelOne);
            }
            else if (level === 3) {
                getLevelThrees(currentLevelTwo);
            }
        }
        if (level === 3) {
            const hardCodes = ["Banks", "CommercialBed", "Agents", "CommercialBes", "Personel", "Purchase", "ReturnFromPurchase", "Sale", "ReturnFromSale"];
            const pHardCodes = ["بانکها", "بدهکاران تجاری", "نمایندگی ها", "بستانکاران تجاری", "پرسنل", "خرید", "برگشت از خرید", "فروش", "برگشت از فروش"];
            const section = ["مدیریت حسابهای بانکی", "طرف حساب ها", "مدیریت پرسنل / نمایندگی ها", "طرف حساب ها", "مدیریت پرسنل / نمایندگی ها", "مدیریت کالاها", "مدیریت کالاها", "مدیریت کالاها", "مدیریت کالاها"];
            const indx = hardCodes.findIndex(h => h === currentLevelTwo.HardCode);
            if (indx >= 0) {
                const msg = `برای حذف ${pHardCodes[indx]} به بخش ${section[indx]} مراجعه کنید`;
                setErrorDialog(dispatch, msg, "حذف حساب");
                return;
            }
        }
        deleteAccount(level, id, onSuccess);
    }
    function setAccColWidth(colName, dec) {
        if (dec) {
            colWidth[colName] = 2;
            colWidth.Level2_3 = 3;
        }
        else {
            colWidth[colName] = 4;
            colWidth.Level2_3 = 2;
        }
        setColWidth({ ...colWidth });
    }
    function findAccount(e) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        if (foundAccounts === "PENDING") {
            return;
        }
        if (skip.current < foundAccounts.TotalCount) {
            skip.current++;
        }
        else {
            skip.current = 0;
        }
        findSpecificAccount(sepecificAcc.current, skip.current, getFoundAccounts);
    }
    function onSearchChanged(value) {
        getFoundAccounts({ Result: [], TotalCount: 0 });
        sepecificAcc.current = value;
        skip.current = 0;
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-امور مالی";
        getAccountLevelOList(getLevelO);
    }, [])
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <Card.Header className="headerStyle" style={{ textAlign: "right" }}>
                    <FontAwesomeIcon icon={faSitemap} size="lg" />
                    &nbsp;
                    مدیریت کدینگ حساب ها
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ minHeight: "75vh" }}>
                    <Row>
                        <Col md={colWidth.LevelO} className="rowBorder" style={{ padding: "3px" }}>
                            <div className="rowTitle">حسابهای گروه
                                {colWidth.LevelO === 4 && <CaretRight size={19} className="hoverIcon" color="#ff2300fa" style={{ cursor: "pointer" }} onClick={() => setAccColWidth("LevelO", true)} />}
                                {colWidth.LevelO === 2 && <CaretLeft size={19} className="hoverIcon" color="#ff2300fa" style={{ cursor: "pointer" }} onClick={() => setAccColWidth("LevelO", false)} />}
                            </div>
                            <div style={{ paddingBottom: !currentLevelO ? "0" : "45px" }}>
                                <Table className="fixedTable scrolledTable mt-2" responsive={true}>
                                    <thead>
                                        <tr >
                                            <th style={{ width: colWidth.LevelO === 4 ? "15%" : "25%" }}>کد</th>
                                            <th style={{ width: colWidth.LevelO === 4 ? "45%" : "75%" }}>نام حساب</th>
                                            {colWidth.LevelO === 4 &&
                                                <Fragment>
                                                    <th style={{ width: "20%" }}>نوع</th>
                                                    <th style={{ minWidth: "20%" }}>ماهیت</th>
                                                </Fragment>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody style={{ maxHeight: "50vh" }}>
                                        {levelO === "PENDING" &&
                                            <tr><td colSpan={4} style={{ textAlign: "center", width: "100%" }}><Loader type="BallTriangle" width={25} height={25} color="#bb1370" /></td></tr>
                                        }
                                        {levelO && Array.isArray(levelO) &&
                                            levelO.map((item, i) => <tr key={i} className="resultTableRow" onClick={() => getLevelOnes(item)}>
                                                <td style={{ width: colWidth.LevelO === 4 ? "15%" : "25%" }}>{item.AccountCode}</td>
                                                <td style={{ width: colWidth.LevelO === 4 ? "45%" : "75%" }}>{item.AccountName}</td>
                                                {colWidth.LevelO === 4 &&
                                                    <Fragment>
                                                        <td style={{ minWidth: "20%" }}>{item.IsFixedAccount ? "دائم" : "موقت"}</td>
                                                        <td style={{ width: "20%" }}>{item.AccountType ? "بدهکار" : "بستانکار"}</td>
                                                    </Fragment>
                                                }
                                            </tr>)
                                        }
                                    </tbody>
                                </Table>

                                {(!currentLevelO || Number(currentLevelO.AccountID) > 0) &&
                                    <div style={{ textAlign: "right" }}>
                                        {<PlusSquare color="blue" size={20} className="hoverIcon" style={{ cursor: "pointer" }}
                                            onClick={() => prepareForAdd(0)} />}
                                    </div>
                                }</div>
                            {currentLevelO &&
                                <div style={{ border: "1px solid #970b7b", padding: "4px", borderRadius: "3px", position: "absolute", bottom: "2px", marginTop: "25px" }}>
                                    <table>
                                        <tbody style={{ color: "red" }}>
                                            <tr>
                                                <td style={{ width: "15%" }}>
                                                    <input type="text" style={{ fontWeight: "bold", background: "#e8e8fa" }} className="tableRowInput"
                                                        value={currentLevelO.AccountCode} onChange={e => onChangeInput(0, e.target.value, "AccountCode")} placeholder="کدحساب" />
                                                </td>
                                                <td>
                                                    <input type="text" style={{ fontWeight: "bold", background: "#e8e8fa" }} disabled={currentLevelO.IsPredefined} className="tableRowInput"
                                                        value={currentLevelO.AccountName} onChange={e => onChangeInput(0, e.target.value, "AccountName")} placeholder="نام حساب" />
                                                </td>
                                                {Number(currentLevelO.AccountID) === 0 &&
                                                    <td style={{ width: "25%", paddingLeft: "0", paddingRight: "0" }}>
                                                        <input type="checkbox" className="form-check-input" onChange={e => onChangeInput(0, e.target.checked, "AccountType")} /><label style={{ marginTop: "2px" }}>بدهکار</label>
                                                        &nbsp;
                                                        <input type="checkbox" className="form-check-input" onChange={e => onChangeInput(0, e.target.checked, "IsFixedAccount")} /><label style={{ marginTop: "2px", color: "blue" }}>دایم</label>
                                                    </td>
                                                }
                                                <td style={{ textAlign: "right" }}>
                                                    {Number(currentLevelO.AccountID) === 0 && <CheckSquare color="green" className="hoverIcon" style={{ cursor: "pointer" }} size={19}
                                                        onClick={() => addAcc(0)} />}
                                                    &nbsp;
                                                    {Number(currentLevelO.AccountID) === 0 && <DashCircle color="red" className="hoverIcon" style={{ cursor: "pointer" }} size={19}
                                                        onClick={() => cancelAdd(0)} />}
                                                    {Number(currentLevelO.AccountID) > 0 &&
                                                        <PencilFill color="orange" size={19} className="hoverIcon" style={{ cursor: "pointer" }} onClick={() => editAcc(0)} />
                                                    }
                                                    &nbsp;
                                                    {Number(currentLevelO.AccountID) > 0 &&
                                                        <Trash color="red" size={19} className="hoverIcon" style={{ cursor: "pointer" }} onClick={() => deleteAcc(0, currentLevelO.AccountID)} />
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            }
                        </Col>
                        <Col md={colWidth.LevelOne} className="rowBorder" style={{ padding: "3px" }}>
                            <div className="rowTitle">حسابهای کل
                                {colWidth.LevelOne === 4 && <CaretRight size={19} className="hoverIcon" color="#ff2300fa" style={{ cursor: "pointer" }} onClick={() => setAccColWidth("LevelOne", true)} />}
                                {colWidth.LevelOne === 2 && <CaretLeft size={19} className="hoverIcon" color="#ff2300fa" style={{ cursor: "pointer" }} onClick={() => setAccColWidth("LevelOne", false)} />}
                            </div>
                            <div style={{ paddingBottom: !currentLevelOne ? "0" : "45px" }}>
                                <Table className="fixedTable  scrolledTable mt-2">
                                    <thead>
                                        <tr>
                                            <th style={{ width: colWidth.LevelOne === 4 ? "15%" : "25%" }}>کد</th>
                                            <th style={{ width: colWidth.LevelOne === 4 ? "45%" : "75%" }}>نام حساب</th>
                                            {colWidth.LevelOne === 4 &&
                                                <Fragment>
                                                    <th style={{ width: "20%" }}>نوع</th>
                                                    <th style={{ minWidth: "20%" }}>ماهیت</th>
                                                </Fragment>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody style={{ maxHeight: "50vh" }}>
                                        {levelOne === "PENDING" &&
                                            <tr><td colSpan={4} style={{ textAlign: "center", width: "100%" }}><Loader type="BallTriangle" width={25} height={25} color="#bb1370" /></td></tr>
                                        }
                                        {levelOne && Array.isArray(levelOne) &&
                                            levelOne.map((item, i) => <tr key={i} className="resultTableRow" onClick={() => getLevelTwoes(item)}>
                                                <td style={{ width: colWidth.LevelOne === 4 ? "15%" : "25%" }}>{item.AccountCode}</td>
                                                <td style={{ width: colWidth.LevelOne === 4 ? "45%" : "75%" }}>{item.AccountName}</td>
                                                {colWidth.LevelOne === 4 &&
                                                    <Fragment>
                                                        <td style={{ minWidth: "20%" }}>{item.IsFixedAccount ? "دائم" : "موقت"}</td>
                                                        <td style={{ width: "20%" }}>{item.AccountType ? "بدهکار" : "بستانکار"}</td>
                                                    </Fragment>
                                                }
                                            </tr>)
                                        }
                                    </tbody>
                                </Table>
                                {(!currentLevelOne || Number(currentLevelOne.AccountID) > 0) && currentLevelO && currentLevelO.AccountID > 0 &&
                                    <div style={{ textAlign: "right" }}>
                                        {<PlusSquare color="blue" size={20} className="hoverIcon" style={{ cursor: "pointer" }}
                                            onClick={() => prepareForAdd(1)} />}
                                    </div>
                                }
                            </div>
                            {currentLevelOne &&
                                <div style={{ border: "1px solid #970b7b", padding: "4px", borderRadius: "3px", position: "absolute", bottom: "2px" }}>
                                    <table>
                                        <tbody style={{ color: "red" }}>
                                            <tr>
                                                <td style={{ width: "15%" }}>
                                                    <input type="text" style={{ fontWeight: "bold", background: "#e8e8fa" }} className="tableRowInput"
                                                        value={currentLevelOne.AccountCode} onChange={e => onChangeInput(1, e.target.value, "AccountCode")} placeholder="کدحساب" />
                                                </td>
                                                <td>
                                                    <input type="text" style={{ fontWeight: "bold", background: "#e8e8fa" }} disabled={currentLevelOne.IsPredefined} className="tableRowInput"
                                                        value={currentLevelOne.AccountName} onChange={e => onChangeInput(1, e.target.value, "AccountName")} placeholder="نام حساب" />
                                                </td>
                                                {Number(currentLevelOne.AccountID) === 0 &&
                                                    <td style={{ width: "25%", paddingLeft: "0", paddingRight: "0" }}>
                                                        <input type="checkbox" className="form-check-input" onChange={e => onChangeInput(1, e.target.checked, "AccountType")} /><label style={{ marginTop: "2px" }}>بدهکار</label>
                                                        &nbsp;
                                                        <input type="checkbox" className="form-check-input" onChange={e => onChangeInput(1, e.target.checked, "IsFixedAccount")} /><label style={{ marginTop: "2px", color: "blue" }}>دایم</label>
                                                    </td>
                                                }
                                                <td style={{ textAlign: "right" }}>
                                                    {Number(currentLevelOne.AccountID) === 0 && <CheckSquare color="green" className="hoverIcon" style={{ cursor: "pointer" }} size={19}
                                                        onClick={() => addAcc(1)} />}
                                                    &nbsp;
                                                    {Number(currentLevelOne.AccountID) === 0 && <DashCircle color="red" className="hoverIcon" style={{ cursor: "pointer" }} size={19}
                                                        onClick={() => cancelAdd(1)} />}
                                                    {Number(currentLevelOne.AccountID) > 0 && <PencilFill color="orange" size={18} className="hoverIcon" style={{ cursor: "pointer" }} onClick={() => editAcc(1)} />}
                                                    &nbsp;
                                                    {Number(currentLevelOne.AccountID) > 0 && <Trash color="red" size={18} className="hoverIcon" style={{ cursor: "pointer" }} onClick={() => deleteAcc(1, currentLevelOne.AccountID)} />}
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            }
                        </Col>
                        <Col md={colWidth.Level2_3} className="rowBorder" style={{ padding: "3px" }}>
                            <div className="rowTitle">حسابهای معین</div>
                            <div style={{ paddingBottom: !currentLevelTwo ? "0" : "45px" }}>
                                <Table className="fixedTable scrolledTable mt-2" >
                                    <thead>
                                        <tr>
                                            <th style={{ width: "35%" }}>کد حساب</th>
                                            <th style={{ width: "65%" }}>نام حساب</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ maxHeight: "50vh" }}>
                                        {levelTwo === "PENDING" &&
                                            <tr><td colSpan={2} style={{ textAlign: "center", width: "100%" }}><Loader type="BallTriangle" width={25} height={25} color="#bb1370" /></td></tr>
                                        }
                                        {levelTwo && Array.isArray(levelTwo) &&
                                            levelTwo.map((item, i) =>
                                                <tr key={i} className="resultTableRow" onClick={() => getLevelThrees(item)}>
                                                    <td style={{ width: "35%" }}>{item.AccountCode}</td>
                                                    <td style={{ width: "65%" }}>{item.AccountName}</td>
                                                </tr>)
                                        }
                                    </tbody>
                                </Table>
                                {(!currentLevelTwo || Number(currentLevelTwo.AccountID) > 0) && currentLevelOne && currentLevelOne.AccountID > 0 &&
                                    <div style={{ textAlign: "right" }}>
                                        {<PlusSquare color="blue" size={20} className="hoverIcon" style={{ cursor: "pointer" }}
                                            onClick={() => prepareForAdd(2)} />}
                                    </div>
                                }
                            </div>
                            {currentLevelTwo &&
                                <div style={{ border: "1px solid #970b7b", padding: "4px", borderRadius: "3px", position: "absolute", bottom: "2px", maxWidth: "98%" }}>
                                    <table>
                                        <tbody style={{ color: "red" }}>
                                            <tr>
                                                <td style={{ width: "15%" }}>
                                                    <input type="text" style={{ fontWeight: "bold", background: "#e8e8fa" }} className="tableRowInput"
                                                        value={currentLevelTwo.AccountCode} onChange={e => onChangeInput(2, e.target.value, "AccountCode")} placeholder="کد" />
                                                </td>
                                                <td style={{ width: "60%" }}>
                                                    <input type="text" style={{ fontWeight: "bold", background: "#e8e8fa" }} disabled={currentLevelTwo.IsPredefined} className="tableRowInput"
                                                        value={currentLevelTwo.AccountName} onChange={e => onChangeInput(2, e.target.value, "AccountName")} placeholder="نام" />
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    {Number(currentLevelTwo.AccountID) === 0 && <CheckSquare color="green" className="hoverIcon" style={{ cursor: "pointer" }} size={19}
                                                        onClick={() => addAcc(2)} />}
                                                    &nbsp;
                                                    {Number(currentLevelTwo.AccountID) === 0 && <DashCircle color="red" className="hoverIcon" style={{ cursor: "pointer" }} size={19}
                                                        onClick={() => cancelAdd(2)} />}
                                                    {Number(currentLevelTwo.AccountID) > 0 && <PencilFill color="orange" size={18} className="hoverIcon" style={{ cursor: "pointer" }} onClick={() => editAcc(2)} />}
                                                    &nbsp;
                                                    {Number(currentLevelTwo.AccountID) > 0 && <Trash color="red" size={18} className="hoverIcon" style={{ cursor: "pointer" }} onClick={() => deleteAcc(2, currentLevelTwo.AccountID)} />}
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            }
                        </Col>
                        <Col md={colWidth.Level2_3} className="rowBorder" style={{ padding: "3px" }}>
                            <div className="rowTitle">حسابهای تفصیلی</div>
                            <div style={{ paddingBottom: !currentLevelThree ? "0" : "45px" }}>
                                <Table responsive className="fixedTable scrolledTable mt-2">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "35%" }}>کد حساب</th>
                                            <th style={{ width: "65%" }}>نام حساب</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ maxHeight: "50vh" }}>
                                        {levelThree === "PENDING" &&
                                            <tr><td colSpan={2} style={{ textAlign: "center", width: "100%" }}><Loader type="BallTriangle" width={25} height={25} color="#bb1370" /></td></tr>
                                        }
                                        {levelThree && Array.isArray(levelThree) &&
                                            levelThree.map((item, i) =>
                                                <tr key={i} className="resultTableRow" onClick={() => setCurrLevel3(item)}>
                                                    <td style={{ width: "35%" }}>{item.AccountCode}</td>
                                                    <td style={{ width: "65%" }}>{item.AccountName}</td>
                                                </tr>)
                                        }
                                    </tbody>
                                </Table>
                                {(!currentLevelThree || Number(currentLevelThree.AccountID) > 0) && currentLevelTwo && currentLevelTwo.AccountID > 0 &&
                                    <div style={{ textAlign: "right" }}>
                                        {<PlusSquare color="blue" size={20} className="hoverIcon" style={{ cursor: "pointer" }}
                                            onClick={() => prepareForAdd(3)} />}
                                    </div>
                                }
                            </div>
                            {currentLevelThree &&
                                <div style={{ border: "1px solid #970b7b", padding: "4px", borderRadius: "3px", position: "absolute", bottom: "2px", maxWidth: "98%" }}>
                                    <table>
                                        <tbody style={{ color: "red" }}>
                                            <tr>
                                                <td style={{ width: "15%" }}>
                                                    <input type="text" style={{ fontWeight: "bold", background: "#e8e8fa" }} className="tableRowInput"
                                                        value={currentLevelThree.AccountCode} onChange={e => onChangeInput(3, e.target.value, "AccountCode")} />
                                                </td>
                                                <td style={{ width: "60%" }}>
                                                    <input type="text" style={{ fontWeight: "bold", background: "#e8e8fa" }} className="tableRowInput"
                                                        value={currentLevelThree.AccountName} onChange={e => onChangeInput(3, e.target.value, "AccountName")} />
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    {Number(currentLevelThree.AccountID) === 0 && <CheckSquare color="green" className="hoverIcon" style={{ cursor: "pointer" }} size={19}
                                                        onClick={() => addAcc(3)} />}
                                                    &nbsp;
                                                    {Number(currentLevelThree.AccountID) === 0 && <DashCircle color="red" className="hoverIcon" style={{ cursor: "pointer" }} size={19}
                                                        onClick={() => cancelAdd(3)} />}
                                                    {Number(currentLevelThree.AccountID) > 0 && <PencilFill color="orange" size={18} className="hoverIcon" style={{ cursor: "pointer" }} onClick={() => editAcc(3)} />}
                                                    &nbsp;
                                                    {Number(currentLevelThree.AccountID) > 0 && <Trash color="red" size={18} className="hoverIcon" style={{ cursor: "pointer" }} onClick={() => deleteAcc(3, currentLevelThree.AccountID)} />}
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            }

                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={6} className="rowBorder" style={{ paddingTop: "20px" }}>
                            <Col md={8}>
                                <input className="form-control" onChange={e => onSearchChanged(e.target.value)} style={{ width: "85%", display: "inline-block" }}
                                    placeholder="نام حساب مورد جستجو" onKeyDown={findAccount} />
                                <Button className="group-Btn-smalll" onClick={findAccount}><Search size={17} /></Button>
                            </Col>
                            <div className="mt-2">
                                {foundAccounts === "PENDING" && <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />}
                                {foundAccounts?.Result && Array.isArray(foundAccounts.Result) &&
                                    foundAccounts.Result.map((item, i) =>
                                        <div key={i} style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", marginTop: "2px" }}>
                                            <div style={{ border: "1px solid #27c9e5", textAlign: "center", padding: "10px", minWidth: "80px", borderRadius: "3px", background: "linear-gradient(0deg, #27c9e5, transparent)" }}>{item.LevelO}</div>
                                            <div style={{ display: "flex" }}><div style={{ margin: "auto" }}><CaretLeftFill size={35} color="#f90681" /></div></div>
                                            <div style={{ border: "1px solid #27c9e5", textAlign: "center", padding: "10px", minWidth: "80px", borderRadius: "3px", background: "linear-gradient(0deg, #27c9e5, transparent)" }}>{item.LevelOne}</div>
                                            <div style={{ display: "flex" }}><div style={{ margin: "auto" }}><CaretLeftFill size={35} color="#f90681" /></div></div>
                                            <div style={{ border: "1px solid #27c9e5", textAlign: "center", padding: "10px", minWidth: "80px", borderRadius: "3px", background: "linear-gradient(0deg, #27c9e5, transparent)" }}>{item.LevelTwo}</div>
                                            <div style={{ display: "flex" }}><div style={{ margin: "auto" }}><CaretLeftFill size={35} color="#f90681" /></div></div>
                                            <div style={{ border: "1px solid #27c9e5", textAlign: "center", padding: "10px", minWidth: "80px", borderRadius: "3px", background: "linear-gradient(0deg, #27c9e5, transparent)" }}>{item.LevelThree}</div>
                                        </div>)}
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    )
}
export default AccountsChart;